import React from 'react'
import clsx from 'clsx'

type Size = number | string

export default function ProfilePic({
    src,
    size = 36,
    alt = 'Profile picture',
    className,
    rounded = true,
}: {
    src?: string
    size?: Size
    alt?: string
    className?: string
    rounded?: boolean
}): React.JSX.Element {
    const widthHeight = typeof size === 'number' ? `${size}px` : size
    const [imgSrc, setImgSrc] = React.useState<string | undefined>(src)
    React.useEffect(() => {
        setImgSrc(src)
    }, [src])

    // Wrap in a square container to prevent any layout from squashing the image
    // Use block + w-full/h-full on the img (no absolute positioning) to avoid flow issues.
    return (
        <div
            className={clsx(
                'relative overflow-hidden inline-block shrink-0 align-middle',
                rounded && 'rounded-full',
                className,
            )}
            style={{ width: widthHeight, height: widthHeight }}
        >
            <img
                src={imgSrc || '/no-profile-pic.svg'}
                alt={alt}
                className="block w-full h-full object-cover"
                loading="lazy"
                draggable={false}
                onError={() => {
                    if (imgSrc !== '/no-profile-pic.svg') {
                        setImgSrc('/no-profile-pic.svg')
                    }
                }}
            />
        </div>
    )
}
